import "./style/content.css";
import { useContact } from '../context/ContactContext';

function Footer(){
    const { phone, email, instagram } = useContact();
    const waLink = phone ? `https://wa.me/${phone.replace(/\D/g, '')}` : 'https://wa.me/628132216607';
    const phoneDisplay = phone ? (phone.startsWith('62') ? `+62 ${phone.slice(2)}` : phone) : '+62 813-2216-607';

    return (
    <footer className="footer-section">
        <div className="footer-container">
            <div className="row text-white">
                <div className='foo-1 col-lg-4 col-md-6 col-12 mb-4'>
                    <h3 className='fw-bold mb-3'>EDCWORKSS</h3>
                    <ul className="footer-links">
                        <li><i className='bi bi-geo-alt'></i> Jl.Raya Panyileukan RW No.9 N0.B.7, Cipadung Kidul, Kec. Panyileukan, Kota Bandung, Jawa Barat 40614</li>
                        <li><a href={waLink} target="_blank" rel="noopener noreferrer"><i className='bi bi-whatsapp'></i> {phoneDisplay}</a></li>
                        <li><i className='bi bi-envelope'></i> {email || 'edcworkss@gmail.com'}</li>
                    </ul>
                </div>

                <div className='foo-2 col-lg-4 col-md-6 col-12 mb-4'>
                    <h5 className="mb-3">Navigation</h5>
                    <ul className="footer-links">
                        <li><a href="#why-us">About</a></li>
                        <li><a href="#service">Service</a></li>
                        <li><a href="#team">Team Gallery</a></li>
                        <li><a href="#portofolio">Portfolio</a></li>
                    </ul>
                </div>

                <div className='foo-3 col-lg-4 col-md-6 col-12 mb-4'>
                    <h5 className="mb-3">Our Social Media</h5>
                    <div className="social-icons">
                        {instagram && <a href={instagram} target="_blank" rel="noopener noreferrer"><i className='bi bi-instagram'></i></a>}
                        <a href="https://www.facebook.com/share/1BTbZBJa1K/?mibextid=wwXlfr" target="_blank" rel="noopener noreferrer"><i className='bi bi-facebook'></i></a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    )
}

export default Footer;
